<template>
  <common-modal-section
    :has-close-button="false"
    class="limited-video-alert-modal-section"
    @close="emitClose"
  >
    <template v-slot:default>
      <youtube :video-id="videoId" ref="youtubeRef" :player-vars="playerVars" />
    </template>

    <template v-slot:buttons>
      <atom-input-button
        :linkText="$tc('common.close')"
        colorType="tertiary"
        :isDisabled="false"
        @push="emitClose()"
      />
    </template>
  </common-modal-section>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

/**
 * HOME 会員限定動画モーダル
 */
export default defineComponent({
  name: 'LimitedVideoModalSection',
  components: {
    CommonModalSection,
    AtomInputButton,
  },
  props: {
    videoId: {
      type: String,
    },
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const youtubeRef = ref<any>(null)

    // Youtube IFrame Playerのインスタンス。
    // 利用できるメソッドについては以下を参照。
    // https://developers.google.com/youtube/iframe_api_reference#Functions
    const youtubePlayer = computed(() => youtubeRef.value.player)

    // Youtube プレーヤーのパラメタ。
    // 参考: https://developers.google.com/youtube/player_parameters.html?playerVersion=HTML5
    const playerVars = { autoplay: 1 }
    return {
      playerVars,
      youtubeRef,
      youtubePlayer,
    }
  },
  methods: {
    /**
     * closeModal
     * 親コンポーネントへ閉じる処理
     */
    emitClose(): void {
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss">
.limited-video-alert-modal-section {
  .atom-icon-link-btn {
    img {
      width: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .modal__content {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
}

::v-deep .modal__buttons {
  margin-top: 0;
  padding: 0;
}

::v-deep .modal__wrapper {
  width: min(100%, 700px);
}
</style>
